export const GROUPS_API_URL = 'ui/partner/groups';

export const groupsQueryKeys = {
  all: () => [GROUPS_API_URL],
  details: () => [...groupsQueryKeys.all(), 'details'],
  detail: (groupId: string) => [...groupsQueryKeys.details(), groupId],
};
